/**
 * Elilhaam — Back in Stock notification handler
 * 
 * On submit:
 * 1. Validates email
 * 2. Saves to localStorage (local log you can read)
 * 3. Sends to Klaviyo Back-in-Stock endpoint (if list ID provided)
 * 4. Sends to custom endpoint / Formspree (if endpoint provided)
 * 5. Sends to store email via EmailJS or endpoint
 * 6. Shows success state
 */

function submitBIS(productId, variantId, productTitle, variantTitle, endpoint, klaviyoList, storeEmail) {
  var emailInput = document.getElementById('bis-email-' + productId);
  var errorEl    = document.getElementById('bis-error-' + productId);
  var btn        = emailInput && emailInput.nextElementSibling;
  var formEl     = document.getElementById('bis-form-' + productId);
  var successEl  = document.getElementById('bis-success-' + productId);

  if (!emailInput) return;

  var email = emailInput.value.trim();

  // Validate
  if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    if (errorEl) errorEl.style.display = 'block';
    emailInput.focus();
    return;
  }
  if (errorEl) errorEl.style.display = 'none';
  if (btn) { btn.disabled = true; btn.textContent = '…'; }

  // 1. Save to localStorage
  try {
    var BIS_KEY = 'elilhaam_bis_v1';
    var stored  = JSON.parse(localStorage.getItem(BIS_KEY) || '[]');
    stored.push({
      email:        email,
      productId:    productId,
      productTitle: productTitle,
      variantId:    variantId,
      variantTitle: variantTitle,
      ts:           new Date().toISOString()
    });
    localStorage.setItem(BIS_KEY, JSON.stringify(stored));
  } catch(e) {}

  var promises = [];

  // 2. Send to Klaviyo Back-in-Stock Subscribe endpoint
  if (klaviyoList) {
    var klaviyoPromise = fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        g:     klaviyoList,
        email: email,
        $fields: '$source',
        $source: 'Back in Stock — ' + productTitle,
      }).toString()
    }).catch(function() {});
    promises.push(klaviyoPromise);
  }

  // 3. Send to custom endpoint / Formspree
  if (endpoint) {
    var endpointPromise = fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        email:        email,
        product:      productTitle,
        variant:      variantTitle,
        product_id:   productId,
        variant_id:   variantId,
        _subject:     'Back in Stock Request — ' + productTitle,
        _replyto:     email,
        source:       'Elilhaam Back in Stock',
        timestamp:    new Date().toISOString()
      })
    }).catch(function() {});
    promises.push(endpointPromise);
  }

  // Show success after all requests (or immediately if none configured)
  Promise.all(promises).then(function() {
    if (formEl)    formEl.style.display    = 'none';
    if (successEl) successEl.style.display = 'block';
    if (btn) { btn.disabled = false; }
  }).catch(function() {
    if (formEl)    formEl.style.display    = 'none';
    if (successEl) successEl.style.display = 'block';
    if (btn) { btn.disabled = false; }
  });
}
